import React from "react";

interface Props {
  nome: string;
  email: string;
  empresa: string;
  cargo: string;
}

export default function UserStaticInfo({ nome, email, empresa, cargo }: Props) {
  return (
    <div className="form-container static-info">
      <div className="static-field">
        <label>Nome</label>
        <p>{nome}</p>
      </div>

      <div className="static-field">
        <label>E-mail</label>
        <p>{email}</p>
      </div>

      <div className="static-field">
        <label>Empresa</label>
        <p>{empresa}</p>
      </div>

      <div className="static-field">
        <label>Cargo</label>
        <p>{cargo}</p>
      </div>
    </div>
  );
}
